module.exports = __webpack_public_path__ + "assets/img/loginBg.327264ab.png";